export default [{
    "caseId": "AFP-1",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/AFP-1.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>William Tyrrell, who was aged just three-years-old at the time of his disappearance, was last seen at his grandmother’s home on Benaroon Drive at Kendall, on the NSW mid‑north coast, on Friday 12 September 2014. He has not been seen since.Detectives from the NSW Police Force’s Homicide Squad are leading the investigation into William’s disappearance and they believe he may have been kidnapped.</p>",
    "contactInformation": "<p>The information you provide could help police find William. If you have information that may assist police to locate William please call Crime Stoppers on <b>1800 333 000</b>.</p><p>Information can be provided anonymously and will be treated in the strictest confidence.</p>",
    "country": "Australia",
    "location": "Kendall NSW",
    "agencyCode": "AFP",
    "agencyName": "Australian Federal Police",
    "fullName": "William Tyrrell",
    "missingDate": "09/12/2014",
    "yearOfBirth": 2011,
    "sex": "male",
    "eyeColor": "Brown",
    "hairColor": "Brown",
    "height": 100,
    "heightUnit": "cms",
    "center": {
      "lat": -31.633333,
      "lng": 152.7
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ACT/logo.png"
  },
  {
    "caseId": "AFP-2",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/AFP-2.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>Rahma El-Dennaoui was at home with her parents and seven other siblings in Hill Road, Lurnea. She was last seen by her parents when she was put in her bed at 2am on Thursday 10 November.</p><p>Rahma was between two of her sisters on a double bed under the bedroom window. About six and half hours later (8.30am) it was discovered she was not in her bed. Her parents were unable to find her inside the house and police were contacted at 9am.</p><p>Police believe Rahma was abducted, although no motive has been proven. Despite extensive investigations and a $250,000 reward being posted for information, police are yet to find Rahma.</p>",
    "contactInformation": "<p>If you have information that may assist police to locate Rahma please call Crime Stoppers on <b>1800 333 000</b>.</p>",
    "country": "Australia",
    "agencyName": "Australian Federal Police",
    "location": "Lurnea, NSW",
    "agencyCode": "AFP",
    "fullName": "Rahma El-Dennaoui",
    "missingDate": "11/10/2005",
    "yearOfBirth": 2004,
    "sex": "female",
    "center": {
      "lat": -33.9326,
      "lng": 150.900826
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ACT/logo.png"
  },
  {
    "caseId": "ARBA-151",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-151.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>Visto por última vez en Rio Grande, Tierra del Fuego en septiembre 2008</p>",
    "contactInformation": "<p>Si tiene información, llame a: <b>134</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Rio Grande, Tierra del Fuego",
    "agencyCode": "ARBA",
    "agencyName": "Argentine Ministry of Security",
    "fullName": "Sofia Yasmin Herrera",
    "missingDate": "28/09/2008",
    "birthday": "30/12/2004",
    "sex": "female",
    "center": {
      "lat": -53.7860374,
      "lng": -67.7002243
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-01.jpg",
    "caseType": "Missing",
    "circumstances": "<p>15 años al momento de su ausencia (03/02/2018). San Vicente, Provincia de Misiones.</p>",
    "contactInformation": "<p>Si tiene información, llame a: <b>134</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "San Vicente, Provincia de Misiones",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Candela Agustina Correas de Melo",
    "missingDate": "03/02/2018",
    "yearOfBirth": 2003,
    "sex": "Female",
    "center": {
      "lat": -26.9954037,
      "lng": -54.4820017
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-02.png",
    "caseType": "Missing",
    "circumstances": "<p>Desaparecido entre los días 18 y 21 de diciembre de 2015. Se encontraba junto a su abuela materna Patricia Daniela Sayago y al conviviente de ésta: Ariel Fernando Malagueño, con quienes fue visto por última vez en la localidad de Montefiore, departamento 9 de julio, Provincia de Santa Fe. Búsqueda de paradero.</p>",
    "contactInformation": "<p>Si tiene información, llame a: <b>134</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Montefiore, Provincia de Santa Fe",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Maximiliano Javier Sosa",
    "missingDate": "18/12/2015",
    "birthday": "01/07/2012",
    "sex": "Male",
    "center": {
      "lat": -29.666732,
      "lng": -61.8665194
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-2523",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-2523.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>Visto por última vez en Florencio Valera, Buenos Aires en abril 2019</p>",
    "contactInformation": "<p>Si tiene información, llame a: <b>134</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Florencio Varela, Buenos Aires",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Tiziano Sebastian Echeverria",
    "missingDate": "04/05/2019",
    "yearOfBirth": 2014,
    "sex": "Male",
    "center": {
      "lat": -34.7965806,
      "lng": -58.27601199999999
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-2524",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-2524.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>Visto por última vez en Alte Brown, Buenos Aires en julio 2019</p>",
    "contactInformation": "<p>Si tiene información, llame a: <b>134</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Alte Brown, Buenos Aires",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Yennifer Ann Marlene Barreiro",
    "missingDate": "07/08/2019",
    "yearOfBirth": 2003,
    "sex": "female",
    "center": {
      "lat": -34.8400613,
      "lng": -58.3945107
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-03.jpg",
    "caseType": "Missing",
    "circumstances": "<p>5 años al momento de su ausencia. (21/07/2015). Ciudad Autónoma de Buenos Aires.</p>",
    "contactInformation": "<p>Si tiene información, llame a: <b>134</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Ciudad Autónoma de Buenos Aires",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Brisa Ayelén Pereyra",
    "missingDate": "21/07/2015",
    "yearOfBirth": 2010,
    "sex": "Male",
    "center": {
      "lat": -34.6036844,
      "lng": -58.3815591
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-2003",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-2003.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>Teléfono: <b>0800 333 5500</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Goya, Corrientes",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Abril Agustina Tomassella",
    "missingDate": "06/08/2016",
    "birthday": "29/06/2007",
    "sex": "female",
    "center": {
      "lat": -29.1442242,
      "lng": -59.2643242
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "ARBA-2004",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ARBA-2004.jpg",
    "caseType": "Unknown",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>Teléfono: <b>0800 333 5500</b></p><p>E-MAIL: <b>info@missingchildren.org.ar</b></p>",
    "country": "Argentina",
    "location": "Goya, Corrientes",
    "agencyCode": "ARBA",
    "agencyName": "SIFEBU",
    "fullName": "Julieta Tomassella",
    "missingDate": "06/08/2016",
    "birthday": "27/06/2012",
    "sex": "female",
    "center": {
      "lat": -29.1442242,
      "lng": -59.2643242
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCA.png"
  },
  {
    "caseId": "BEBR-CM18488",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/BEBR-CM18488.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>CONTACT <b>116 000 (24/24 - 7/7)</b></p>",
    "country": "Belgium",
    "location": "Bruxelles-Capitale, Sint-Pieters-Woluwe",
    "agencyCode": "BEBR",
    "agencyName": "Child Focus",
    "fullName": "Sabri Ajrode",
    "missingDate": "08/01/2018",
    "birthday": "31/12/2009",
    "sex": "male",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": 135,
    "heightUnit": "cms",
    "center": {
      "lat": 50.8299809,
      "lng": 4.4335038
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/BEBR/logo.png"
  },
  {
    "caseId": "BEBR-CM18489",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/BEBR-CM18489.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>CONTACT <b>116 000 (24/24 - 7/7)</b></p>",
    "country": "Belgium",
    "location": "Bruxelles-Capitale, Sint-Pieters-Woluwe",
    "agencyCode": "BEBR",
    "agencyName": "Child Focus",
    "fullName": "Jamal Ajrode",
    "missingDate": "31/07/2018",
    "birthday": "31/12/2003",
    "sex": "male",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": 175,
    "heightUnit": "cms",
    "center": {
      "lat": 50.8299809,
      "lng": 4.4335038
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/BEBR/logo.png"
  },
  {
    "caseId": "BEBR-CM19815",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/BEBR-CM19815.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>CONTACT <b>116 000 (24/24 - 7/7)</b></p>",
    "country": "Belgium",
    "location": "Bruxelles-Capitale, IXELLES",
    "agencyCode": "BEBR",
    "agencyName": "Child Focus",
    "fullName": "Malik Shorya",
    "missingDate": "24/05/2019",
    "birthday": "31/12/2005",
    "sex": "male",
    "hairColor": "Black",
    "height": 155,
    "heightUnit": "cms",
    "center": {
      "lat": 50.83334319999999,
      "lng": 4.3666294
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/BEBR/logo.png"
  },
  {
    "caseId": "MDH-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-01.jpg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>CONTACT <b>116 000 (24/24 - 7/7)</b></p>",
    "country": "Brazil",
    "location": "Manus, Amazonas.",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Erlon Gabriel",
    "missingDate": "06/02/2020",
    "birthday": "31/12/2005",
    "sex": "Male",
    "hairColor": "Black",
    "height": 155,
    "heightUnit": "cms",
    "center": {
      "lat": -3.1190275,
      "lng": -60.0217314
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-04",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-04.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "João Carlos",
    "country": "Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "location": "São Paulo, Atibaia.",
    "missingDate": "13/01/2019",
    "birthday": "31/12/2004",
    "sex": "Male",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>Tel. <b>11 3337 3331</b></p>",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -23.1175492,
      "lng": -46.5567066
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-02.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>A vitma estava em casa no bairro Jardim Iguacu em Rondonopolis / MT, quando desapareceu.</p>",
    "contactInformation": "<p>Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Jardim Iguacu, Nova Iguaçu.",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Samuel Victor Da Silva Carvalho",
    "missingDate": "19/10/2019",
    "birthday": "31/12/2013",
    "sex": "Male",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -22.742049,
      "lng": -43.4704991
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-06",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-06.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Wendell Santos Costa",
    "country": "Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "location": "Rio de Janeiro, Conselho Tutelar de Beford Roxo.",
    "missingDate": "13/01/2018",
    "birthday": "27/02/2006",
    "sex": "Male",
    "circumstances": "<p>Wendell saiu de casa dizendo que iria para a lan house e desapareceu.</p>",
    "contactInformation": "<p>Disque<b>100</b></p>",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -22.7435099,
      "lng": -43.4068158
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-03.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Local visto pela ultima vez: Em casa, logo depois de ter tomado um Uber com destino a ponte Rio Negro em - Manaus Amazonia.</p>",
    "contactInformation": "<p>Tel. <b>11 3337 3331</b></p>",
    "country": "Brazil",
    "location": "Amazonas, Manaus.",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Joany Martins Cristino",
    "missingDate": "24/07/2019",
    "birthday": "31/12/2004",
    "sex": "Female",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -3.1190275,
      "lng": -60.0217314
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-07",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-07.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Local visto pela ultima vez: Em casa, logo depois de ter tomado um Uber com destino a ponte Rio Negro em - Manaus Amazonia.</p>",
    "contactInformation": "<p>Tel. <b>11 3337 3331</b> / <b>21 2286 8337</b> / <b>21 98596 5296</b> Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Rio de Janeiro, Campo Grande",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Julia Soares De Moura",
    "missingDate": "29/11/2019",
    "sex": "Female",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -22.9076515,
      "lng": -43.5659121
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-08",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-08.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Visto pela última vez emPiracicaba, SP em março de 2016. O menino brincava em um sitio quando desapareceu.</p>",
    "contactInformation": "<p>Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "São Paulo, Piracicaba",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "João Victor Soares",
    "missingDate": "10/03/2016",
    "birthday": "19/01/2013",
    "sex": "Male",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -22.7355889,
      "lng": -47.6478542
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-09",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-09.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Local visto pela ultima vez: Em casa, logo depois de ter tomado um Uber com destino a ponte Rio Negro em - Manaus Amazonia .</p>",
    "contactInformation": "<p>Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Rio de Janeiro, Rio de Janeiro",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Victor Hugo de Oliveira",
    "missingDate": "14/03/2019",
    "sex": "Male",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -22.9068467,
      "lng": -43.1728965
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-10",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-10.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Visto pela última vez em Telemaco Borba, PR em junho de 2017. Luiz brincava em frente a sua casa quando desapareceu.</p>",
    "contactInformation": "<p>Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Telemaco Borba, Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Luiz Felipe Dos Santos Machado",
    "missingDate": "26/06/2017",
    "birthday": "31/12/2014",
    "sex": "Male",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -24.3237385,
      "lng": -50.6206959
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-11",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-11.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Vista pela última vez em Jaraguá do Sul, SC, em maio de 2014. Local visto pela ultima vez: Em casa, logo depois de ter tomado um Uber com destino a ponte Rio Negro em - Manaus Amazonia .</p>",
    "contactInformation": "<p>Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Santa Catarina, Jaragua do Sul, Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Emiçi Miranda Anacleto",
    "missingDate": "20/05/2014",
    "birthday": "20/06/2012",
    "sex": "Female",
    "hairColor": "loira",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -26.4822209,
      "lng": -49.073477
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-12",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-12.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Visto pela última vez em Caxias do Sul, RS, em setembro de 2017</p>",
    "contactInformation": "<p>Policia Militar de Santa Catarina: <b>48 3665 4715</b> / <b>48 99156 8264</b>. Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Rio Grande do Sul, De Caxias do Sul, Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Dielson Michael Sroczynski",
    "missingDate": "17/09/2017",
    "birthday": "31/12/2001",
    "sex": "Male",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -29.1634031,
      "lng": -51.1796683
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-13",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-13.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Vista pela última vez em Cascavel, PR em dezembro de 2016. Tatiele saiu de casa para buscar uma ferramenta em local incerto e disapareceu.</p>",
    "contactInformation": "<p>Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Cascavel, Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Tatiele Terra Felipe",
    "missingDate": "12/12/2016",
    "birthday": "31/12/2005",
    "sex": "Female",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -24.9577771,
      "lng": -53.45951119999999
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-14",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-14.jpeg",
    "caseType": "Endangered Missing",
    "circumstances": "<p>Local visto pela ultima vez: Em casa, logo depois de ter tomado um Uber com destino a ponte Rio Negro em - Manaus Amazonia .</p>",
    "contactInformation": "<p>Tel. <b>11 3337 3331</b>. Caso tenha informações, ligue para o Disque <b>100</b></p>",
    "country": "Brazil",
    "location": "Paraná, Cerro Azul, Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "fullName": "Brayan Raab Fonseca",
    "missingDate": "18/06/2017",
    "birthday": "31/12/2014",
    "sex": "Male",
    "hairColor": "loiro",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -24.8257258,
      "lng": -49.2628453
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "MDH-05",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDH-05.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Douglas Rafael Da S.l. Braz",
    "country": "Brazil",
    "agencyCode": "MDH",
    "agencyName": "MDH",
    "location": "Rio de Janeiro, Conselho Tutelar de Beford Roxo.",
    "missingDate": "06/08/2018",
    "birthday": "31/12/2007",
    "sex": "Male",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>Tel. <b>21 2286 8337 / 21 98596 5296</b></p>",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "center": {
      "lat": -22.7435099,
      "lng": -43.4068158
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MDH.png"
  },
  {
    "caseId": "RCMP-2014006252",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RCMP-2014006252.jpeg",
    "caseType": "Missing",
    "circumstances": "<p>Meagan Rose Pilon was 15 years old at the time of her disappearance. She was living in the New Sudbury area of Ontario. The last confirmed sighting of Meagan was on September 12, 2013 at her family's home. Due to the length of time Meagan has been missing, police have not been able to rule out foul play in her disappearance.</p>",
    "contactInformation": "<p>Greater Sudbury Police Service: <b>705-675-9171 ext 6632</b><br />Reference Case#: <b>M13-SU13043034</b></p><p>Crime Stoppers: <b>1-800-222-TIPS(8477)</b> or online at <b>https://www.canadiancrimestoppers.org/tips</b></p><p>Crime Stoppers provides anonymous tipping</p>",
    "country": "Canada",
    "location": "Sudbury, Ontario",
    "agencyCode": "RCMP",
    "agencyName": "RCMP",
    "fullName": "Meagan Rose Pilon",
    "aliases": "KRISTIA, LILY, Lexi",
    "missingDate": "12/09/2013",
    "yearOfBirth": 1997,
    "sex": "Female",
    "eyeColor": "Hazel",
    "hairColor": "Black, Long",
    "height": 178,
    "heightUnit": "cms",
    "weight": 68,
    "weightUnit": "kgs",
    "center": {
      "lat": 46.4917317,
      "lng": -80.99302899999999
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCSC.png"
  },
  {
    "caseId": "RCMP-2012020012",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RCMP-2012020012.jpeg",
    "caseType": "Missing",
    "circumstances": "<p>Jeffrey Surtel was last seen April 28, 2007 at his residence in Mission, BC. Jeff is believed to have left his home riding a distinctive blue CCM mountain bike with yellow forks.</p>",
    "contactInformation": "<p>Mission RCMP: <b>604-826-7161</b></p><p>Reference Case#: <b>2007-05465</b></p><p>Crime Stoppers: <b>1-800-222-TIPS(8477)</b> or online at <b>https://www.canadiancrimestoppers.org/tips</b></p><p>Crime Stoppers provides anonymous tipping</p>",
    "country": "Canada",
    "location": "Mission, British Columbia",
    "agencyCode": "MCSC",
    "agencyName": "MCSC",
    "fullName": "Jeffrey Stuart Surtel",
    "missingDate": "28/04/2007",
    "yearOfBirth": 1990,
    "sex": "Male",
    "eyeColor": "Blue",
    "hairColor": "Brown, Short",
    "height": 185,
    "heightUnit": "cms",
    "weight": 68,
    "weightUnit": "kgs",
    "center": {
      "lat": 49.1329272,
      "lng": -122.3261603
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCSC.png"
  },
  {
    "caseId": "RCMP-2014002590",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RCMP-2014002590.jpeg",
    "caseType": "Missing",
    "circumstances": "<p>On April 15, 2000, Merlin Labrie left an evening spent with friends in Levis, Quebec. He was suppose to meet up with a friend but never made it and was never seen again.</p>",
    "contactInformation": "<p>Service de police de la Ville de Lévis: <b>1-418-832-2911</b></p><p>Reference Case#: <b>ETC-000415-004</b></p><p>Crime Stoppers: <b>1-800-222-TIPS(8477)</b> or online at <b>https://www.canadiancrimestoppers.org/tips</b></p><p>Crime Stoppers provides anonymous tipping</p>",
    "country": "Canada",
    "location": "Levis, Québec",
    "agencyCode": "MCSC",
    "agencyName": "MCSC",
    "fullName": "Merlin Labrie",
    "missingDate": "14/04/2000",
    "yearOfBirth": 1984,
    "sex": "Male",
    "eyeColor": "Brown",
    "hairColor": "Blonde, Brush Cut",
    "height": 168,
    "heightUnit": "cms",
    "weight": 59,
    "weightUnit": "kgs",
    "center": {
      "lat": 46.7382265,
      "lng": -71.2464591
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCSC.png"
  },
  {
    "caseId": "RCMP-2012020006",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RCMP-2012020006.jpeg",
    "caseType": "Missing",
    "circumstances": "<p>Lucas James Degerness was last seen on June 7, 2007 in Prince George, BC. He spent that night with a friend.</p>",
    "contactInformation": "<p>Prince George RCMP: <b>(250)561-3300</b></p><p>Reference Case#: <b>2007-20640</b></p><p>Crime Stoppers: <b>1-800-222-TIPS(8477)</b> or online at <b>https://www.canadiancrimestoppers.org/tips</b></p><p>Crime Stoppers provides anonymous tipping</p>",
    "country": "Canada",
    "location": "Prince george, British Columbia",
    "agencyCode": "MCSC",
    "agencyName": "MCSC",
    "fullName": "Lucas James Degerness",
    "aliases": "DEGERNESS, Luke",
    "missingDate": "07/06/2007",
    "yearOfBirth": 1993,
    "sex": "Male",
    "eyeColor": "Brown",
    "hairColor": "Brown, Other, Short",
    "height": 173,
    "heightUnit": "cms",
    "weight": 66,
    "weightUnit": "kgs",
    "center": {
      "lat": 53.9170641,
      "lng": -122.7496693
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCSC.png"
  },
  {
    "caseId": "RCMP-2014005946",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RCMP-2014005946.jpeg",
    "caseType": "Missing",
    "fullName": "Elena Iordache",
    "circumstances": "<p>Elena Iordache was last seen on December 22, 2012, in Montreal. Elena lived in a youth center and mentioned that she did not want to spend the holidays there. She left without bringing any of her personal belongings.</p>",
    "contactInformation": "<p>Email at <b>canadasmissing-disparuscanada@rcmp-grc.gc.ca</b></p>",
    "agencyCode": "MCSC",
    "agencyName": "MCSC",
    "country": "Canada",
    "location": "Quebec, Montreal",
    "birthday": "17/05/1998",
    "missingDate": "21/12/2012",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": 168,
    "heightUnit": "cms",
    "weight": 56,
    "weightUnit": "kgs",
    "center": {
      "lat": 45.5016889,
      "lng": -73.567256
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCSC.png"
  },
  {
    "caseId": "RCMP-2014006260",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RCMP-2014006260.jpeg",
    "caseType": "Missing",
    "fullName": "Qasim Zolfaqari",
    "circumstances": "<p>Qasim Zolfaqari was last seen on September 20, 2013, in Montreal. M. Zolfaqari arrived in Canada on July 12, 2013, from Holland, but is originally from Afghanistan. He may have frequented the Gay Village area of Montreal or could be in Ontario.</p>",
    "contactInformation": "<p>Email at <b>canadasmissing-disparuscanada@rcmp-grc.gc.ca</b></p>",
    "agencyCode": "MCSC",
    "agencyName": "MCSC",
    "country": "Canada",
    "location": "Quebec, Montreal",
    "birthday": "21/10/1995",
    "missingDate": "19/09/2013",
    "sex": "Male",
    "eyeColor": "Brown",
    "hairColor": "Brown",
    "height": 181,
    "heightUnit": "cms",
    "weight": 71,
    "weightUnit": "kgs",
    "center": {
      "lat": 45.5016889,
      "lng": -73.567256
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCSC.png"
  },
  {
    "caseId": "MDIEC-202003210831322-D",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDIEC-202003210831322-D.jpeg",
    "caseType": "Missing",
    "fullName": "Lourdes Elizabeth Pilatasig Toapanta",
    "circumstances": "<p>Fue visto por última vez el 06 de marzo de 2020 en PICHINCHA, QUITO, SAN LUIS DE CHILLOGALLO.</p>",
    "contactInformation": "<p>Tel. <b>1800 335486</b></p>",
    "agencyCode": "MDIEC",
    "agencyName": "Ministry of Government",
    "country": "Ecuador",
    "location": "Pichincha, Quitumbe",
    "missingDate": "06/03/2020",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Brown",
    "height": 150,
    "heightUnit": "cms",
    "weight": 91,
    "weightUnit": "lbs",
    "center": {
      "lat": -0.3074098,
      "lng": -78.52633050000001
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/MDIEC/logo.png"
  },
  {
    "caseId": "MDIEC-202003040538495-D",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDIEC-202003040538495-D.jpeg",
    "caseType": "Missing",
    "fullName": "Alan Jafet Puwainchir Tzamarenda",
    "circumstances": "<p>Fue visto por última vez el 15 de febrero de 2020 en PICHINCHA, QUITO, CALLES JULIO ANDRADE Y LUIS CHIPANTIZA SECTOR DE LA NUEVA AURORA.</p>",
    "contactInformation": "<p>Tel. <b>1800 335486</b></p>",
    "agencyCode": "MDIEC",
    "agencyName": "Ministry of Government",
    "country": "Ecuador",
    "location": "Pichincha, Quitumbe",
    "missingDate": "15/02/2020",
    "sex": "Male",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": 110,
    "heightUnit": "cms",
    "weight": 70,
    "weightUnit": "lbs",
    "center": {
      "lat": -0.3074098,
      "lng": -78.52633050000001
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/MDIEC/logo.png"
  },
  {
    "caseId": "MDIEC-202002150015411-D",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDIEC-202002150015411-D.jpeg",
    "caseType": "Missing",
    "fullName": "Kadilea Gabrielle Garcia Nazur",
    "circumstances": "<p>Fue visto por última vez el 24 de noviembre de 2019 en GUAYAS, GUAYAQUIL, PUERTO AZUL MZ E2 SOLAR 22.</p>",
    "contactInformation": "<p>Tel. <b>1800 335486</b></p>",
    "agencyCode": "MDIEC",
    "agencyName": "Ministry of Government",
    "country": "Ecuador",
    "location": "Guayas, Ceibos.",
    "missingDate": "24/11/2019",
    "sex": "Female",
    "eyeColor": "Grey",
    "hairColor": "Black",
    "height": 110,
    "heightUnit": "cms",
    "weight": 50,
    "weightUnit": "lbs",
    "center": {
      "lat": -2.1666402,
      "lng": -79.94511349999999
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/MDIEC/logo.png"
  },
  {
    "caseId": "MDIEC-202003201032165-D",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDIEC-202003201032165-D.jpeg",
    "caseType": "Missing",
    "fullName": "Naomy Yudith Osorio Goiburo",
    "circumstances": "<p>Fue visto por última vez el 15 de marzo de 2020 en GUAYAS, GUAYAQUIL, PASCUALES, URBANIZACIÓN BEATA MERCEDES MOLINA BLOQUE 4, VILLA 32.</p>",
    "contactInformation": "<p>Tel. <b>1800 335486</b></p>",
    "agencyCode": "MDIEC",
    "agencyName": "Ministry of Government",
    "country": "Ecuador",
    "location": "Guayas, Pascuales.",
    "missingDate": "15/03/2020",
    "sex": "Female",
    "eyeColor": "Black",
    "hairColor": "Black",
    "height": 155,
    "heightUnit": "cms",
    "weight": 68,
    "weightUnit": "lbs",
    "center": {
      "lat": -2.0721549,
      "lng": -79.9345141
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/MDIEC/logo.png"
  },
  {
    "caseId": "MDIEC-201912270933344-D",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MDIEC-201912270933344-D.jpeg",
    "caseType": "Missing",
    "fullName": "Lue Mathias Rodriguez Flores",
    "circumstances": "<p>Fue visto por última vez el 08 de diciembre de 2019 en EL ORO, MACHALA, VIA FERROVIARIA DIAGONAL AL SUBCENTRO VELAZCO IBARRA.</p>",
    "contactInformation": "<p>Tel. <b>1800 335486</b></p>",
    "agencyCode": "MDIEC",
    "agencyName": "Ministry of Government",
    "country": "Ecuador",
    "location": "El oro, Machacala.",
    "missingDate": "08/12/2019",
    "sex": "Male",
    "eyeColor": "Black",
    "hairColor": "Black",
    "height": 100,
    "heightUnit": "cms",
    "weight": 40,
    "weightUnit": "lbs",
    "center": {
      "lat": -3.2581112,
      "lng": -79.9553924
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/MDIEC/logo.png"
  },
  {
    "caseId": "GEVK-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/GEVK-01.jpg",
    "caseType": "Missing",
    "fullName": "Inga Gehricke",
    "circumstances": "<p>Last seen in Wlhelmshof (Stendal) in May 2015.</p>",
    "contactInformation": "<p>If you have info, call <b>116 000</b></p>",
    "agencyCode": "GEVK",
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/GEVK.jpg",
    "agencyName": "Initative Vermisste Kinder",
    "country": "Germany",
    "location": "Wilhelmshof (Stendal)",
    "missingDate": "01/05/2015",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 52.569049,
      "lng": 11.584281
    }
  },
  {
    "caseId": "GEVK-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/GEVK-02.jpg",
    "caseType": "Missing",
    "fullName": "Rebecca Reusch",
    "circumstances": "<p>Last seen in Berlin in February 2019.</p>",
    "contactInformation": "<p>If you have info, call <b>116 000</b></p>",
    "agencyCode": "GEVK",
    "agencyName": "Initative Vermisste Kinder",
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/GEVK.jpg",
    "country": "Germany",
    "location": "Berlin",
    "missingDate": "01/02/2019",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 52.52000659999999,
      "lng": 13.404954
    }
  },
  {
    "caseId": "GEVK-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/GEVK-03.jpg",
    "caseType": "Missing",
    "fullName": "Katrin Konert",
    "circumstances": "<p>Last seen in Bergen a.d. Dumme in January 2001.</p>",
    "contactInformation": "<p>If you have info, call <b>116 000</b></p>",
    "agencyCode": "GEVK",
    "agencyName": "Initative Vermisste Kinder",
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/GEVK.jpg",
    "country": "Germany",
    "location": "Bergen a.d. Dumme",
    "missingDate": "01/01/2001",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 52.88333300000001,
      "lng": 10.966667
    }
  },
  {
    "caseId": "GEVK-04",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/GEVK-04.jpg",
    "caseType": "Missing",
    "fullName": "Hilal Ercan",
    "circumstances": "<p>Last seen in Hamburg in January 1999.</p>",
    "contactInformation": "<p>If you have info, call <b>116 000</b></p>",
    "agencyCode": "GEVK",
    "agencyName": "Initative Vermisste Kinder",
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/GEVK.jpg",
    "country": "Germany",
    "location": "Hamburg",
    "missingDate": "01/01/1999",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 53.5510846,
      "lng": 9.9936819
    }
  },
  {
    "caseId": "RRSC-387",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RRSC-387.jpeg",
    "caseType": "Missing",
    "fullName": "Niazi Samir",
    "circumstances": "<p>Εξαφανίστηκε από τον καταυλισμό 'Άγιος Ανδρέας', στη Νέα Μάκρη.</p>",
    "contactInformation": "<p>Unknown</p>",
    "agencyCode": "RRSC",
    "agencyName": "Smile of the Child",
    "country": "Greece",
    "location": "Attikḯ, Nea Makri.",
    "missingDate": "22/12/2019",
    "birthday": "31/12/2006",
    "sex": "Male",
    "eyeColor": "Black",
    "hairColor": "Black",
    "height": 55,
    "heightUnit": "cms",
    "weight": 45,
    "weightUnit": "kgs",
    "center": {
      "lat": 38.0878845,
      "lng": 23.9761139
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/TSC.png"
  },
  {
    "caseId": "RRSC-E0B072EBA81277D5DC6C3C2206DA51D9",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RRSC-E0B072EBA81277D5DC6C3C2206DA51D9.jpg",
    "caseType": "Endangered Missing",
    "fullName": "ΜΟΧΙΣΑ ΧΟΡΜΑΤ",
    "circumstances": "<p>Στις 2/7/2019, κατά τις απογευματινές ώρες εξαφανίστηκε από τη περιοχή της Αθήνας η Μοχίσα Χορμάτ, 16 ετών, αφγανικής καταγωγής. Το «Χαμόγελο του Παιδιού» προχώρησε σήμερα, 5/7/2019, στη δημοσιοποίηση των στοιχείων της ανήλικης κατόπιν εισαγγελικής εντολής της Εισαγγελέως Ανηλίκων της Εισαγγελίας Πρωτοδικών Αθηνών. Η Μοχίσα Χορμάτ έχει ύψος 1.61μ. ζυγίζει 47 κιλά, έχει καστανά μακριά μαλλιά και καστανά μάτια. Την ημέρα που εξαφανίστηκε φορούσε τζιν παντελόνι, μπλε πουκαμίσα, και μαύρη ή μπλε μαντίλα.</p>",
    "contactInformation": "<p>The Smile of the Child - <b>116 000</b></p>",
    "agencyCode": "RRSC",
    "agencyName": "Smile of the Child",
    "country": "Greece",
    "location": "Greece",
    "missingDate": "01/07/2019",
    "birthday": "20/01/2003",
    "sex": "Female",
    "eyeColor": "καστανα",
    "hairColor": "καστανα μακρια",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 39.074208,
      "lng": 21.824312
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/TSC.png"
  },
  {
    "caseId": "RRSC-9A686E047805C85521B2666543FBCBCF",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RRSC-9A686E047805C85521B2666543FBCBCF.jpg",
    "caseType": "Endangered Missing",
    "fullName": "ΑΝΕΛΙΑ Ν.",
    "circumstances": "<p>Στις 10/04/2019 και ώρα 14:00, εξαφανίστηκε από την περιοχή των Αμπελοκήπων στην Αθήνα, η Ανέλια Ν., 14 ετών. Η Ανέλια Ν. έχει ύψος 1.55 μ., ζυγίζει 45 κιλά, έχει μαύρα μαλλιά και μαύρα μάτια. Φορούσε άσπρο τζιν παντελόνι, μαύρη ζακέτα και άσπρα αθλητικά παπούτσια.</p>",
    "contactInformation": "<p>The Smile of the Child - <b>116 000</b></p>",
    "agencyCode": "RRSC",
    "agencyName": "Smile of the Child",
    "country": "Greece",
    "location": "Greece",
    "missingDate": "09/04/2019",
    "birthday": "16/11/2004",
    "sex": "Female",
    "eyeColor": "μαυρα",
    "hairColor": "μαυρα",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 39.074208,
      "lng": 21.824312
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/TSC.png"
  },
  {
    "caseId": "RRSC-873CC501CDE6CC91ECF7DDF38CD12D12",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RRSC-873CC501CDE6CC91ECF7DDF38CD12D12.jpg",
    "caseType": "Endangered Missing",
    "fullName": "ΘΕΜΙΣΤΟΚΛΗΣ ΕΥΘΥΜΙΑΔΗΣ",
    "circumstances": "<p>Εξαφανίστηκε στην Αθήνα στις 30/6/2000 σε ηλικία 18 ετών. Έχει ύψος 1.60 μ.Ημερομηνία Γέννησης: 28/10/1984.</p>",
    "contactInformation": "<p>The Smile of the Child - <b>116 000</b></p>",
    "agencyCode": "RRSC",
    "agencyName": "Smile of the Child",
    "country": "Greece",
    "location": "Greece",
    "missingDate": "29/06/2000",
    "birthday": "27/10/1984",
    "sex": "Male",
    "eyeColor": "μαυρα",
    "hairColor": "μαυρα",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 39.074208,
      "lng": 21.824312
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/TSC.png"
  },
  {
    "caseId": "RRSC-6B4E14D7B5BDD64F716AD2AD1ABD3F84",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RRSC-6B4E14D7B5BDD64F716AD2AD1ABD3F84.jpg",
    "caseType": "Endangered Missing",
    "fullName": "ΓΕΩΡΓΙΟΣ ΠΑΡΑΣΚΕΥΟΠΟΥΛΟΣ",
    "circumstances": "<p>Εξαφανίστηκε από το χωριό Δήμητρα Γορτυνίας στις 24/6/1992 σε ηλικία 10 ετών.Ημερομηνία Γέννησης: 5/3/1982.</p>",
    "contactInformation": "<p>The Smile of the Child - <b>116 000</b></p>",
    "agencyCode": "RRSC",
    "agencyName": "Smile of the Child",
    "country": "Greece",
    "location": "Greece",
    "missingDate": "23/06/1992",
    "birthday": "04/03/1982",
    "sex": "Male",
    "eyeColor": "καστανά",
    "hairColor": "καστανόξανθα",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 39.074208,
      "lng": 21.824312
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/TSC.png"
  },
  {
    "caseId": "RRSC-7068105FC83CF1BB60DBC475356F0F4A",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/RRSC-7068105FC83CF1BB60DBC475356F0F4A.jpg",
    "caseType": "Endangered Missing",
    "fullName": "ΜΟΥΚΤΑΡ ΤΑΜΠΙΣ",
    "circumstances": "<p>Στις 20/4/2019, και ώρα 18:00, εξαφανίστηκε από την περιοχή της Ομόνοιας στην Αθήνα, ο Μουκτάρ (επ.) Ταμπίς (ον.), 15 ετών, πακιστανικής καταγωγής. Το «Χαμόγελο του Παιδιού» προχώρησε σήμερα, 21/5/2019, στη δημοσιοποίηση των στοιχείων του ανήλικου κατόπιν εισαγγελικής εντολής της Εισαγγελέως Ανηλίκων της Εισαγγελίας Πρωτοδικών Αθηνών. Τα στοιχεία του Μουκτάρ Ταμπίς προκύπτουν κατά δήλωση του ίδιου. Ο Μουκτάρ Ταμπίς έχει ύψος 1,60 μ., έχει βάρος 60 κ., έχει μαύρα μαλλιά και μαύρα μάτια. Ο Ταμπίς φορούσε σκουρόχρωμο παντελόνι, μαύρο μπουφάν και μαύρα αθλητικά παπούτσια.</p>",
    "contactInformation": "<p>The Smile of the Child - <b>116 000</b></p>",
    "agencyCode": "RRSC",
    "agencyName": "Smile of the Child",
    "country": "Greece",
    "location": "Greece",
    "missingDate": "19/04/2019",
    "birthday": "12/02/2004",
    "sex": "Male",
    "eyeColor": "μαυρα",
    "hairColor": "μαυρα",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 39.074208,
      "lng": 21.824312
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/TSC.png"
  },
  {
    "caseId": "GTPGN-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/GTPGN-01.png",
    "caseType": "Missing",
    "fullName": "Mabelin Fernanda Ramirez Pascual",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<p>Alba-Keneth - <b>0919-2020</b></p>",
    "agencyCode": "GTPGN",
    "agencyName": "Alba Keneth",
    "country": "Guatemala",
    "location": "Bella Vista, San Andres, Peten.",
    "missingDate": "29/02/2020",
    "yearOfBirth": 2019,
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": "",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 16.9742146,
      "lng": -89.9183149
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/AK.png"
  },
  {
    "caseId": "ITRM-3",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITRM-3.png",
    "caseType": "Missing",
    "fullName": "Vanessa Lo Rosso",
    "circumstances": "<p>La minore si trovava presso una comunità con la madre ed il fratello, anche lui minorenne. In data 29 novembre 2019 la madre è uscita con i figli, senza fare più rientro. The child was in a social community with her mother and her brother. On 29th of November 2019 her mother went out with her sons without ever returning.</p>",
    "contactInformation": "<p>Ministero dell'Interno - Direzione Centrale Anticrimine - Servizio Centrale Anticrimine 06/46543550 - Questura di Bologna - Ufficio Minori <b>+39 3313726706</b></p>",
    "agencyCode": "ITRM",
    "agencyName": "Telefono Azzurro",
    "country": "Italy",
    "location": "Emilia-Romagna, Bologna.",
    "missingDate": "28/11/2019",
    "birthday": "07/11/2005",
    "sex": "Female",
    "eyeColor": "Green",
    "hairColor": "Black",
    "height": "",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 44.494887,
      "lng": 11.3426162
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/PDS.png"
  },
  {
    "caseId": "ITRM-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITRM-01.jpeg",
    "caseType": "Missing",
    "fullName": "Livia Clara Schepp",
    "circumstances": "<p>Le sorelle sono state viste per l'ultima volta alle ore 13 circa nei pressi dell'abitazione del padre a Saint Sulpice vicino Losanna (Svizzera). Il padre è morto investito da un treno pochi giorni dopo la scomparsa, nella notte tra il 3 e il 4 febbraio 2011 nei pressi della Stazione ferroviaria di Cerignola (Foggia). Alessia Vere porta occhiali da vista in titanio color bordeaux, indossa una t-shirt bianca a righe bianche, rosse e rosa, una giacca bianca con interni beige, jeans blu e stivali neri. Livia Clara indossa una maglietta verde, una giacca da sci viola, jeans blu, scarpe da ginnastica bianche e rosa Adidas, porta occhiali da vista in titanio color arancio.</p>",
    "contactInformation": "<p>Posted and Supported by: ITALY: Direzione Centrale Anticrimine della Polizia di StatoSezione Minori E-mail - <b>sezioneminori@interno.it</b>------Squadra Mobile della Questura di Foggia (FG) - Tel. <b>0881668111</b></p>",
    "agencyCode": "ITRM",
    "agencyName": "Polizia di Stato",
    "country": "Italy",
    "location": "Saint Sulpice, Lausanne, Switzerland.",
    "missingDate": "30/01/2011",
    "birthday": "07/10/2004",
    "sex": "Female",
    "eyeColor": "Green",
    "hairColor": "Blonde",
    "height": "115",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 46.51011399999999,
      "lng": 6.558195100000001
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/PDS.png"
  },
  {
    "caseId": "ITRM-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITRM-02.jpeg",
    "caseType": "Missing",
    "fullName": "Alessia Vere Schepp",
    "circumstances": "<p>Le sorelle sono state viste per l'ultima volta alle ore 13 circa nei pressi dell'abitazione del padre a Saint Sulpice vicino Losanna (Svizzera). Il padre è morto investito da un treno pochi giorni dopo la scomparsa, nella notte tra il 3 e il 4 febbraio 2011 nei pressi della Stazione ferroviaria di Cerignola (Foggia). Alessia Vere porta occhiali da vista in titanio color bordeaux, indossa una t-shirt bianca a righe bianche, rosse e rosa, una giacca bianca con interni beige, jeans blu e stivali neri. Livia Clara indossa una maglietta verde, una giacca da sci viola, jeans blu, scarpe da ginnastica bianche e rosa Adidas, porta occhiali da vista in titanio color arancio.</p>",
    "contactInformation": "<p>Posted and Supported by: ITALY: Direzione Centrale Anticrimine della Polizia di StatoSezione Minori E-mail - <b>sezioneminori@interno.it</b>------Squadra Mobile della Questura di Foggia (FG) - Tel. <b>0881668111</b></p>",
    "agencyCode": "ITRM",
    "agencyName": "Polizia di Stato",
    "country": "Italy",
    "location": "Saint Sulpice, Lausanne, Switzerland.",
    "missingDate": "30/01/2011",
    "birthday": "07/10/2004",
    "sex": "Female",
    "eyeColor": "Green",
    "hairColor": "Blonde",
    "height": "115",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 46.51011399999999,
      "lng": 6.558195100000001
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/PDS.png"
  },
  {
    "caseId": "ITRM-71",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITRM-71.jpeg",
    "caseType": "Missing",
    "fullName": "Jasmine Eleonora Sbaragli",
    "circumstances": "<p>La minore è stata sottratta dalla madre OSMAN ABDI Saida, cittadina somala, che l’ha probabilmente condotta all’estero.</p>",
    "contactInformation": "<p>Posted and Supported by: ITALY: Direzione Centrale Anticrimine della Polizia di StatoSezione Minori E-mail - <b>sezioneminori@interno.it</b>------Squadra Mobile della Questura di Foggia (FG) - Tel. <b>0881668111</b></p>",
    "agencyCode": "ITRM",
    "agencyName": "Polizia di Stato",
    "country": "Italy",
    "location": "Lucca.",
    "missingDate": "01/01/2009",
    "birthday": "18/01/2003",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Brown",
    "height": "105",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 43.8429197,
      "lng": 10.5026977
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/PDS.png"
  },
  {
    "caseId": "ITRM-69",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITRM-69.jpeg",
    "caseType": "Missing",
    "fullName": "Neve Adele Fiorentino",
    "circumstances": "<p>La minore, che era affidata dal Tribunale per i Minorenni di Brescia ai Servizi Sociali del Comune di Milano, veniva sottratta dalla madre CIRELLI Simona.</p>",
    "contactInformation": "<p>Posted and Supported by: ITALY: Direzione Centrale Anticrimine della Polizia di StatoSezione Minori E-mail - <b>sezioneminori@interno.it</b>------Squadra Mobile della Questura di Foggia (FG) - Tel. <b>0881668111</b></p>",
    "agencyCode": "ITRM",
    "agencyName": "Polizia di Stato",
    "country": "Italy",
    "location": "Brescia.",
    "missingDate": "11/06/2008",
    "birthday": "12/07/2003",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Brown",
    "height": "105",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 45.5415526,
      "lng": 10.2118019
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/PDS.png"
  },
  {
    "caseId": "HTCC-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/HTCC-01.jpg",
    "caseType": "Missing",
    "fullName": "Alexia Baugh",
    "circumstances": "<p>Last seen in Swaby's Hope District in April 2020</p>",
    "contactInformation": "<p>If you have info, call <b>929-0431</b></p>",
    "agencyCode": "HTCC",
    "agencyName": "Hear the Children's Cry",
    "country": "Jamaica",
    "location": "Swaby's Hope District",
    "missingDate": "01/04/2020",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 18.0400185,
      "lng": -77.5040174
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/HCC.png"
  },
  {
    "caseId": "HTCC-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/HTCC-02.jpg",
    "caseType": "Missing",
    "fullName": "Chavell Thomas",
    "circumstances": "<p>Last seen in Spanish Town, St. Catherine in May 2020</p>",
    "contactInformation": "<p>If you have info, call <b>929-0431</b></p>",
    "agencyCode": "HTCC",
    "agencyName": "Hear the Children's Cry",
    "country": "Jamaica",
    "location": "Spanish Town, St. Catherine",
    "missingDate": "01/05/2020",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 18.0166835,
      "lng": -76.9748123
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/HCC.png"
  },
  {
    "caseId": "HTCC-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/HTCC-03.jpg",
    "caseType": "Missing",
    "fullName": "Dejonae Peterson",
    "circumstances": "<p>Last seen in Stony Hill, St. Andrew in April 2020</p>",
    "contactInformation": "<p>If you have info, call <b>929-0431</b></p>",
    "agencyCode": "HTCC",
    "agencyName": "Hear the Children's Cry",
    "country": "Jamaica",
    "location": "Stony Hill, St. Andrew",
    "missingDate": "01/04/2020",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 18.0736829,
      "lng": -76.7942403
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/HCC.png"
  },
  {
    "caseId": "HTCC-04",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/HTCC-04.jpg",
    "caseType": "Missing",
    "fullName": "Shanquan",
    "circumstances": "<p>Last seen in Lagos Drive, Kingston in April 2020</p>",
    "contactInformation": "<p>If you have info, call <b>929-0431</b></p>",
    "agencyCode": "HTCC",
    "agencyName": "Hear the Children's Cry",
    "country": "Jamaica",
    "location": "Lagos Drive, Kingston",
    "missingDate": "01/04/2020",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 18.0178743,
      "lng": -76.8099041
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/HCC.png"
  },
  {
    "caseId": "KENYA-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KENYA-01.jpg",
    "caseType": "Missing",
    "fullName": "Alvin Kiprop",
    "circumstances": "<p>Last seen in Ponda Mali - Nakuru West in February 2020</p>",
    "contactInformation": "<p>If you have info, call <b>800 22 33 44</b></p>",
    "agencyCode": "KENYA",
    "agencyName": "Missing Child Kenya",
    "country": "Kenya",
    "location": "Ponda Mali - Nakuru West.",
    "missingDate": "01/02/2020",
    "birthday": "",
    "sex": "Male",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": -0.3030988,
      "lng": 36.080026
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KENYA.png"
  },
  {
    "caseId": "KENYA-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KENYA-02.jpg",
    "caseType": "Missing",
    "fullName": "Jewel Lenora Kamau",
    "circumstances": "<p>Last seen in Dandora Phase 1, Nairobi in April 2020</p>",
    "contactInformation": "<p>If you have info, call <b>800 22 33 44</b></p>",
    "agencyCode": "KENYA",
    "agencyName": "Missing Child Kenya",
    "country": "Kenya",
    "location": "Dandora Phase 1 - Nairobi",
    "missingDate": "01/04/2020",
    "birthday": "",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": -1.2531617,
      "lng": 36.8976626
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KENYA.png"
  },
  {
    "caseId": "KENYA-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KENYA-03.jpg",
    "caseType": "Missing",
    "fullName": "Latisha Akinyi Otieno",
    "circumstances": "<p>Last seen in Mukuru Kwa Njenga, Nairobi in April 2020</p>",
    "contactInformation": "<p>If you have info, call <b>800 22 33 44</b></p>",
    "agencyCode": "KENYA",
    "agencyName": "Missing Child Kenya",
    "country": "Kenya",
    "location": "Mukuru KWA Njenga - Nairobi",
    "missingDate": "01/04/2020",
    "birthday": "",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": -1.3213091,
      "lng": 36.884217
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KENYA.png"
  },
  {
    "caseId": "KENYA-04",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KENYA-04.jpg",
    "caseType": "Missing",
    "fullName": "Samuel Hans Omondi",
    "circumstances": "<p>Last seen in Ekige-Nyamira County in February 2020</p>",
    "contactInformation": "<p>If you have info, call <b>800 22 33 44</b></p>",
    "agencyCode": "KENYA",
    "agencyName": "Missing Child Kenya",
    "country": "Kenya",
    "location": "Ekige - Nyamira County",
    "missingDate": "01/02/2020",
    "birthday": "",
    "sex": "Male",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": -0.6782712,
      "lng": 35.0591758
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KENYA.png"
  },
  {
    "caseId": "KENYA-05",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KENYA-05.jpg",
    "caseType": "Missing",
    "fullName": "Tracy Wambui",
    "circumstances": "<p>Last seen in Huruma, Nairobi in December 2019</p>",
    "contactInformation": "<p>If you have info, call <b>800 22 33 44</b></p>",
    "agencyCode": "KENYA",
    "agencyName": "Missing Child Kenya",
    "country": "Kenya",
    "location": "Huruma - Nairobi",
    "missingDate": "01/12/2019",
    "birthday": "",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": -1.2564898,
      "lng": 36.8721139
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KENYA.png"
  },
  {
    "caseId": "ITAK-19-0185",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITAK-19-0185.jpg",
    "caseType": "Missing",
    "fullName": "Aleksandra Anna Gładysiak",
    "circumstances": "<p>Unknown.</p>",
    "contactInformation": "<p>ITAKA Centre for Missing People (Poland) <b>+48 22 654 70 70</b></p>",
    "agencyCode": "ITAKA",
    "agencyName": "ITAKA",
    "country": "Poland",
    "location": "Kujawsko-Pomorskie, Włocławek.",
    "missingDate": "10/03/2019",
    "birthday": "31/01/2003",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "Blonde",
    "height": "160",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 52.6483303,
      "lng": 19.0677357
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ITAK/logo.jpeg"
  },
  {
    "caseId": "ITAK-20-0109",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITAK-20-0109.jpg",
    "caseType": "Missing",
    "fullName": "Julia Pietrzak",
    "circumstances": "<p>Unknown.</p>",
    "contactInformation": "<p>ITAKA Centre for Missing People (Poland) <b>+48 22 654 70 70</b></p>",
    "agencyCode": "ITAKA",
    "agencyName": "ITAKA",
    "country": "Poland",
    "location": "Wielkopolskie, Piła.",
    "missingDate": "24/02/2020",
    "birthday": "31/01/2003",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "Blonde",
    "height": "168",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 53.1509671,
      "lng": 16.7382266
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ITAK/logo.jpeg"
  },
  {
    "caseId": "ITAK-20-0134",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITAK-20-0134.jpg",
    "caseType": "Missing",
    "fullName": "Gabriela Zawadzka",
    "circumstances": "<p>Unknown.</p>",
    "contactInformation": "<p>ITAKA Centre for Missing People (Poland) <b>+48 22 654 70 70</b></p>",
    "agencyCode": "ITAKA",
    "agencyName": "ITAKA",
    "country": "Poland",
    "location": "Pomorskie, Gdańsk.",
    "missingDate": "04/03/2020",
    "birthday": "31/01/2005",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 54.35202520000001,
      "lng": 18.6466384
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ITAK/logo.jpeg"
  },
  {
    "caseId": "ITAK-17-0275",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITAK-17-0275.jpg",
    "caseType": "Endangered Missing",
    "fullName": "Dominika Paćkowska",
    "circumstances": "<p>Unknown.</p>",
    "contactInformation": "<p>ITAKA Centre for Missing People (Poland) <b>+48 22 654 70 70</b></p>",
    "agencyCode": "ITAKA",
    "agencyName": "ITAKA",
    "country": "Poland",
    "location": "Płock, Poland.",
    "missingDate": "13/04/2017",
    "birthday": "31/01/2000",
    "sex": "Female",
    "eyeColor": "Niebieskie",
    "hairColor": "",
    "height": "169",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 52.5463446,
      "lng": 19.7065364
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ITAK/logo.jpeg"
  },
  {
    "caseId": "ITAK-19-0172",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/ITAK-19-0172.jpg",
    "caseType": "Missing",
    "fullName": "Klaudia Sienkiewicz",
    "circumstances": "<p>Unknown.</p>",
    "contactInformation": "<p>ITAKA Centre for Missing People (Poland) <b>+48 22 654 70 70</b></p>",
    "agencyCode": "ITAKA",
    "agencyName": "ITAKA",
    "country": "Poland",
    "location": "Podlaskie, Wasilków.",
    "missingDate": "10/02/2018",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "",
    "height": "164",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 53.1986,
      "lng": 23.20779
    },
    "agencyLogo": "https://gmcngine-prod-assets.s3.amazonaws.com/agencies/ITAK/logo.jpeg"
  },
  {
    "caseId": "NeDopusti-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NeDopusti-01.png",
    "caseType": "Missing",
    "fullName": "Belykh Danila",
    "circumstances": "<p>Пропал ребенок! Данила Белых, 10 лет, с.Большая Кузьминка, Липецкая область Может находиться в Москве или области, а так же в любом регионе! Просим помочь распространить информацию.</p>",
    "contactInformation": "<p>Координатор поисков: Координатор в Большой Кузьминк</p><p>Телефон: <b>8 495 226 0143</b></p>",
    "agencyCode": "NeDopusti",
    "agencyName": "NeDopusti",
    "country": "Russia",
    "location": "Bol'shaya Kuz'minka, Lipetsk.",
    "missingDate": "10/02/2018",
    "sex": "Male",
    "age": "15",
    "eyeColor": "",
    "hairColor": "",
    "height": "140",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 52.7510905,
      "lng": 39.7167222
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/RCMC/logo.jpeg"
  },
  {
    "caseId": "NeDopusti-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NeDopusti-02.png",
    "caseType": "Missing",
    "fullName": "Anisimova Anya",
    "circumstances": "<p>Если вы видели этого ребенка или что-либо знаете о том, где девочка находится сейчас, пожалуйста, сообщите в полицию по телефонам: 43-02-02, 79-41-64 (8 отдел УВД по г. Тюмени).</p>",
    "contactInformation": "<p>Если у Вас есть информация о пропавшем ребенке, сообщите по телефону 8 495 226 0143</b></p>",
    "agencyCode": "NeDopusti",
    "agencyName": "NeDopusti",
    "country": "Russia",
    "location": "Tyumen.",
    "missingDate": "10/12/2010",
    "sex": "Female",
    "age": "12",
    "eyeColor": "",
    "hairColor": "",
    "height": "160",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "kgs",
    "center": {
      "lat": 57.1553394,
      "lng": 65.5618637
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/RCMC/logo.jpeg"
  },
  {
    "caseId": "NeDopusti-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NeDopusti-03.png",
    "caseType": "Missing",
    "fullName": "Tishkina Lisa",
    "circumstances": "<p>7 марта Лиза не вернулась домой из школы № 1. Последний раз девочку видели в районе стадиона \"Авангард\" около 10.30 утра. </p>",
    "contactInformation": "<p>Любую информацию способствующую поиску Лизы или возможных преступников можно сообщить по телефонам: +7 83130 5-73-07, +7 83130 5-64-66, или 02. Волонтеры +7 910 892-09-60, +7 915 036-07-94, +7 920 063-27-18 или написать на почту poiskdetei@yandex.ru</p><p>Tel. <b>8 495 226 0143</b></p>",
    "agencyCode": "NeDopusti",
    "agencyName": "NeDopusti",
    "country": "Russia",
    "location": "Sarov.",
    "missingDate": "07/03/2009",
    "sex": "Female",
    "age": "10",
    "eyeColor": "",
    "hairColor": "",
    "height": "140",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 54.9342792,
      "lng": 43.3252503
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/RCMC/logo.jpeg"
  },
  {
    "caseId": "NeDopusti-04",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NeDopusti-04.png",
    "caseType": "Missing",
    "fullName": "Kostyunin Pavel",
    "circumstances": "<p>Unknown</p>",
    "contactInformation": "<div><p>Координатор поисков: Алла</p> <p>Телефон: +79028076372</p><p>3а информацию о месте нахождение ребенка награда 500000 рублей</p><p>Tel. <b>8 495 226 0143</b></p></div>",
    "agencyCode": "NeDopusti",
    "agencyName": "NeDopusti",
    "country": "Russia",
    "location": "Pleasing.",
    "missingDate": "12/06/2011",
    "sex": "Male",
    "age": "6",
    "eyeColor": "Blue",
    "hairColor": "Light",
    "height": "110",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 61.52401,
      "lng": 105.318756
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/RCMC/logo.jpeg"
  },
  {
    "caseId": "NeDopusti-05",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NeDopusti-05.png",
    "caseType": "Missing",
    "fullName": "Cetina Katya",
    "circumstances": "<p>Катя пропала 12 июня 2010 года около 16 часов по местному времени с места стоянки туристов, расположенной на территории Кишертского района Пермского края (на границе с Кунгурским районом Пермского края), на правом берегу реки Сылва, в 2 км выше по течению (юго-восточнее) от скального массива «Ермак-Камень». Приметы: рост 117-120 см, худощавого телосложения, волосы светло-русые длиной ниже плеч, обычно заплетены в две косички, брови густые, глаза голубые. Особые приметы: на момент исчезновения (12.06.2010) на левой пазухе носа, ближе к кончику носа, имелся линейный след от ожога, длиной до 1 см (образовался 23.05.2010). Была одета: футболка синего цвета с изображением на передней части двух медведей жёлтого цвета, шорты короткие зелёного цвета, на правой ноге сланец из полимерного материала розового цвета (либо босиком), в мочках ушей золотые серёжки в виде сердечек.</p>",
    "contactInformation": "<div><p>Координатор поисков: Координатор в Отрадном</p><p>Tel. <b>8 495 226 0143</b></p></div>",
    "agencyCode": "NeDopusti",
    "agencyName": "NeDopusti",
    "country": "Russia",
    "location": "Pleasing.",
    "missingDate": "06/12/2010",
    "sex": "Female",
    "age": "12",
    "eyeColor": "Blue",
    "hairColor": "Light brown",
    "height": "120",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 61.52401,
      "lng": 105.318756
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/RCMC/logo.jpeg"
  },
  {
    "caseId": "NMPC-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NMPC-01.png",
    "caseType": "Missing",
    "fullName": "Francisco de Asis Molina Sanchez",
    "circumstances": "<p>DESAPARECIÓ EL 02/07/2015 EN CÓRDOBA. EDAD: 16 AÑOS. MIDE 1.75 Y PESA 75 KG. LA ÚLTIMA VEZ QUE SE LE VIO VESTÍA POLO BLANCO CON BANDERA DE ESPAÑA EN CUELLO Y MANGAS, PANTALÓN CORTO VAQUERO Y ZAPATILLAS NEGRAS CON DOS RAYAS BLANCAS A LOS LADOS.</p>",
    "contactInformation": "<div><p>Policía <b>091</b></p><p>Guardia Civil <b>062</b></p><p>Email <b>colaboracion-cndes@interior.es</b></p><div>",
    "agencyCode": "NMPC",
    "agencyName": "NMPC",
    "country": "Spain",
    "location": "Córdoba. Córdoba, Andalucía",
    "missingDate": "02/07/2015",
    "birthday": "24/10/1998",
    "sex": "Male",
    "eyeColor": "Marrón",
    "hairColor": "Negro corto",
    "height": "175",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 37.8881751,
      "lng": -4.7793835
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/ESNI/logo.png"
  },
  {
    "caseId": "NMPC-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/NMPC-02.png",
    "caseType": "Missing",
    "fullName": "Malen Zoe Ortiz Rodriguez",
    "circumstances": "<p>DESAPARECIÓ EL 02/12/2013. EN CALVIÁ (ILLES BALEARS). EDAD: 15 AÑOS. MIDE 1.6 Y PESA 55 KG. LA ÚLTIMA VEZ QUE SE LE VIO VESTÍA PANTALON VAQUERO, CHAQUETA VAQUERA AZUL, CAMISA DE CUADROS CELESTE.</p>",
    "contactInformation": "<div><p>Policía <b>091</b></p><p>Guardia Civil <b>062</b></p><p>Email <b>colaboracion-cndes@interior.es</b></p><div>",
    "agencyCode": "NMPC",
    "agencyName": "NMPC",
    "country": "Spain",
    "location": "Calvia. Illes Balears, Baleares",
    "missingDate": "02/12/2013",
    "birthday": "28/10/1998",
    "sex": "Female",
    "eyeColor": "Marrón",
    "hairColor": "Castaño, ondulado, largo",
    "height": "160",
    "heightUnit": "cms",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 39.5653483,
      "lng": 2.5033683
    },
    "agencyLogo": "https://s3.amazonaws.com/gmcngine-dev-assets/agencies/ESNI/logo.png"
  },
  {
    "caseId": "MCCH-001-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MCCH-001-01.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Denisa",
    "circumstances": "<p>Possibly in Algeria / Vielleicht in Algerien / Peut-être en Algerie.</p>",
    "contactInformation": "<p>+41 76 824 34 82</p>",
    "agencyCode": "MCCH",
    "agencyName": "Missing Children CH",
    "country": "Switzerland",
    "location": "Valais.",
    "missingDate": "30/09/2019",
    "birthday": "31/12/2011",
    "sex": "Female",
    "eyeColor": "",
    "hairColor": "Blond",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 46.1904614,
      "lng": 7.5449226
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCS.png"
  },
  {
    "caseId": "MCCH-001-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/MCCH-001-02.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Enzo",
    "circumstances": "<p>Possibly in Algeria / Vielleicht in Algerien / Peut-être en Algerie.</p>",
    "contactInformation": "<p>+41 76 824 34 82</p>",
    "agencyCode": "MCCH",
    "agencyName": "Missing Children CH",
    "country": "Switzerland",
    "location": "Valais.",
    "missingDate": "30/09/2019",
    "birthday": "31/12/2009",
    "sex": "Male",
    "eyeColor": "",
    "hairColor": "Blond",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 46.1904614,
      "lng": 7.5449226
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/MCS.png"
  },
  {
    "caseId": "TW-1841",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/TW-1841.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Huang Chun-hao (黃群皓)",
    "circumstances": "<p>Huang told his mom he was going out with his classmate and diappeared ever since.《tall and thin; wearing glasses》群皓在失蹤當天告知家人要與同學見面，群皓未如期赴約，只在海邊小徑找到上鎖的腳踏車(身形高瘦、失蹤時戴黑框眼鏡)</p>",
    "contactInformation": "<div><p>www.missingkids.org.tw</p><p>TEL：<b>886-4-22265905</b></p><p>FAX：<b>886-4-22202312</b></p><p>E-mail: missing@cwlf.org.tw</p></div>",
    "agencyCode": "TW",
    "agencyName": "Child Welfare League Foundation",
    "country": "Taiwan",
    "location": "T'ai-tung, 台東市",
    "missingDate": "19/12/2011",
    "birthday": "21/02/1995",
    "sex": "Male",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": "175",
    "heightUnit": "cms",
    "weight": "58",
    "weightUnit": "kgs",
    "center": {
      "lat": 22.7613207,
      "lng": 121.1438152
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/CWLF.png"
  },
  {
    "caseId": "TW-1756",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/TW-1756.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Liang, Chun-ting(梁羣婷)",
    "circumstances": "<p>Liang runaway from home and go missing.《Forehead with scar; single eyelids》羣婷自家中離開，離家時精神狀況不甚穩定（額頭上有疤痕、單眼皮）</p>",
    "contactInformation": "<div><p>www.missingkids.org.tw</p><p>TEL：<b>886-4-22265905</b></p><p>FAX：<b>886-4-22202312</b></p><p>E-mail: missing@cwlf.org.tw</p></div>",
    "agencyCode": "TW",
    "agencyName": "Child Welfare League Foundation",
    "country": "Taiwan",
    "location": "Kao-hsiung, 高雄市",
    "missingDate": "04/02/2009",
    "birthday": "11/09/1991",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": "169",
    "heightUnit": "cms",
    "weight": "60",
    "weightUnit": "kgs",
    "center": {
      "lat": 22.6272784,
      "lng": 120.3014353
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/CWLF.png"
  },
  {
    "caseId": "TW-1768",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/TW-1768.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Lai, Hong-cheng (賴泓誠)",
    "circumstances": "<p>Lai was playing near the front door of his house. Disappeared after being left alone for a short while by his grandmother.《Crop hair; double-fold eyelids; burn scar on right elbow》在2014年底，不到二歲的泓誠在家門口附近玩，家人一進屋裡出來後，泓誠就不知去向，至今都沒有消息。(雙眼皮、平頭、右手肘外側有燙傷疤痕)</p>",
    "contactInformation": "<div><p>www.missingkids.org.tw</p><p>TEL：<b>886-4-22265905</b></p><p>FAX：<b>886-4-22202312</b></p><p>E-mail: missing@cwlf.org.tw</p></div>",
    "agencyCode": "TW",
    "agencyName": "Child Welfare League Foundation",
    "country": "Taiwan",
    "location": "T'ai-nan, 台南市南化區",
    "missingDate": "18/12/2014",
    "birthday": "09/05/2013",
    "sex": "Male",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": "70",
    "heightUnit": "cms",
    "weight": "12",
    "weightUnit": "kgs",
    "center": {
      "lat": 22.6158015,
      "lng": 120.7120023
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/CWLF.png"
  },
  {
    "caseId": "TW-2112",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/TW-2112.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Yang, Siou-jheng (楊秀幀)",
    "circumstances": "<p>Go missing after school. (double eyelids, color hair to light brown, there is white ringworm under eyes and throat) 秀幀於放學後，還曾致電家人告知要回家了，沒想到卻從此沒了音訊。(頭髮染成奶油色，雙眼及喉嚨下方皆長有白癬)</p>",
    "contactInformation": "<div><p>www.missingkids.org.tw</p><p>TEL：<b>886-4-22265905</b></p><p>FAX：<b>886-4-22202312</b></p><p>E-mail: missing@cwlf.org.tw</p></div>",
    "agencyCode": "TW",
    "agencyName": "Child Welfare League Foundation",
    "country": "Taiwan",
    "location": "Kao-hsiung, 高雄市",
    "missingDate": "08/03/2020",
    "birthday": "07/01/2003",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Light brown",
    "height": "158",
    "heightUnit": "cms",
    "weight": "45",
    "weightUnit": "kgs",
    "center": {
      "lat": 22.6272784,
      "lng": 120.3014353
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/CWLF.png"
  },
  {
    "caseId": "TW-2103",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/TW-2103.jpeg",
    "caseType": "Endangered Missing",
    "fullName": "Li, Yu-pei (李玉佩)",
    "circumstances": "<p>Runaway from home. (double eyelids, dark skin, left handed, long dark hair) 離開家後，卻未到學校上課。失蹤至今都未與家人聯絡。(體型高大、雙眼皮、膚色較黑，慣用左手。離家時黑色直髮及肩)</p>",
    "contactInformation": "<div><p>www.missingkids.org.tw</p><p>TEL：<b>886-4-22265905</b></p><p>FAX：<b>886-4-22202312</b></p><p>E-mail: missing@cwlf.org.tw</p></div>",
    "agencyCode": "TW",
    "agencyName": "Child Welfare League Foundation",
    "country": "Taiwan",
    "location": "New Taipei, 新北市",
    "missingDate": "15/12/2019",
    "birthday": "27/01/2003",
    "sex": "Female",
    "eyeColor": "Brown",
    "hairColor": "Black",
    "height": "172",
    "heightUnit": "cms",
    "weight": "72",
    "weightUnit": "kgs",
    "center": {
      "lat": 25.0622095,
      "lng": 121.4570447
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/CWLF.png"
  },
  {
    "caseId": "KERALA-01",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KERALA-01.png",
    "caseType": "Missing",
    "fullName": "Sreejith",
    "circumstances": "<p>Last seen in Muthuvankudi in November 2013</p>",
    "contactInformation": "<p>If you have info, call <b>9497980389</b></p>",
    "agencyCode": "KERALA",
    "agencyName": "Kerala",
    "country": "India",
    "location": "Muthuvankudi",
    "missingDate": "01/11/2013",
    "birthday": "",
    "sex": "Male",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 10.0363124,
      "lng": 77.2182409
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KERALA.jpg"
  },
  {
    "caseId": "KERALA-02",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KERALA-02.png",
    "caseType": "Missing",
    "fullName": "Vishnukumar",
    "circumstances": "<p>Last seen in Ramavarmapuram in September 2014</p>",
    "contactInformation": "<p>If you have info, call <b>9497990084</b></b></p>",
    "agencyCode": "KERALA",
    "agencyName": "Kerala",
    "country": "India",
    "location": "Ramavarmapuram",
    "missingDate": "01/09/2014",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 10.5599101,
      "lng": 76.2334278
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KERALA.jpg"
  },
  {
    "caseId": "KERALA-03",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KERALA-03.png",
    "caseType": "Missing",
    "fullName": "Karthik",
    "circumstances": "<p>Last seen in Kavalapara Colony, Puthukallu, Malappuram in August 2019</p>",
    "contactInformation": "<p>If you have info, call <b>9497980692</b></p>",
    "agencyCode": "KERALA",
    "agencyName": "Kerala",
    "country": "India",
    "location": "KAVALAPPARA COLONY, POTHUKALLU,MALAPPURAM",
    "missingDate": "01/08/2019",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 11.4044715,
      "lng": 76.25008439999999
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KERALA.jpg"
  },
  {
    "caseId": "KERALA-04",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KERALA-04.png",
    "caseType": "Missing",
    "fullName": "Sonukumar",
    "circumstances": "<p>Last seen in Ramavarmapuram in August 2014</p>",
    "contactInformation": "<p>If you have info, call <b>9497990084</b></p>",
    "agencyCode": "KERALA",
    "agencyName": "Kerala",
    "country": "India",
    "location": "Ramavarmapuram",
    "missingDate": "01/08/2014",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 10.5599101,
      "lng": 76.2334278
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KERALA.jpg"
  },
  {
    "caseId": "KERALA-05",
    "photo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-dashboard-children-images/KERALA-05.png",
    "caseType": "Missing",
    "fullName": "Anil Krishnan",
    "circumstances": "<p>Last seen in Kokkadu, Chakkuvarakkal in May 2016</p>",
    "contactInformation": "<p>If you have info, call <b>9497947141</b></p>",
    "agencyCode": "KERALA",
    "agencyName": "Kerala",
    "country": "India",
    "location": "Kokkadu,Chakkuvarakkal",
    "missingDate": "01/05/2016",
    "birthday": "",
    "sex": "Unknown",
    "eyeColor": "",
    "hairColor": "",
    "height": "",
    "heightUnit": "",
    "weight": "",
    "weightUnit": "",
    "center": {
      "lat": 8.9801421,
      "lng": 76.87509829999999
    },
    "agencyLogo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-agencies/KERALA.jpg"
  }
]